<!--
 * @FileDescription: 模板（注释描述）
 * @Author: ryb（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: ryb（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container">
      <div class="temp-tip">
          <div class="temp-tip-left">
              <img src="@/assets/image/tip@2x.png"/>
              <span>温馨提示：</span>
          </div>
          <div class="temp-tip-right">
              <div>1，用于设定导入数据的格式，可以让导入数据时更好的和后台数据进行匹配</div>
              <div>2，导入的数据列必须和模板的字段，排序一致</div>
          </div>
      </div>
      <div class="temp-content">
          <a-tabs :defaultActiveKey="tabIndex"
                  @change="callbackTab"
                  class="a-tabs-theme">
              <a-tab-pane tab="财务数据"
                          key="1">
                  <div class="display-flex">
                      <template >
                        <cardTemp ref="cardTem" @onDelete="onDelete" :width="494" :height="168">
                            <div class="card-item">
                                <div>财务数据模板名称1</div>
                                <div class="card-button">
                                    <a-button class="btn-watch" @click="onWatchTemp">预览</a-button>
                                    <a-button class="btn-edit"  @click="onAddTemp(2)">编辑</a-button>
                                </div>
                            </div>
                        </cardTemp>
                      </template>
                      <div  class="account-li">
                          <div  class="account-li-content add-card">
                              <img src="@/assets/image/card-template@2x.png" class="add-card-left"/>
                              <div class="add-card-right">
                                  <a-button icon="plus" class="add-card-right-btn" @click="onAddTemp(1)">新增模板</a-button>
                                  <div class="add-card-right-text">点击上方按钮，新增模板</div>
                              </div>
                          </div>
                      </div>
                  </div>
              </a-tab-pane>
              <a-tab-pane tab="库存数据"
                          key="2"
                          forceRender>Content of Tab Pane 2</a-tab-pane>
              <a-tab-pane tab="客户数据"
                          key="3">Content of Tab Pane 3</a-tab-pane>
              <a-tab-pane tab="商城数据"
                          key="4">Content of Tab Pane 3</a-tab-pane>
          </a-tabs>
          <model :width="1200" :title="title" ref="model" :cancelText="cancelText" :confirmText="confirmText" @onCofrim="onCofrimForm" :isShow="isShowModel" @onCancel="onCancel">
              <div class="select-content">
                  <div class="temp-select">
                      <div class="select-left">
                          <div class="select-duan-left">
                              <div class="star">*</div>
                              <div>模板名称</div>
                          </div>
                          <a-input placeholder="请输入模板名称" v-model="temName" class="select-input"></a-input>
                      </div>
                      <div class="select-left">
                          <div class="select-duan-left">
                              <div class="star">*</div>
                              <div>选择字段</div>
                          </div>
                          <div class="select-duan-right">
                              <div v-for="(item,index) in selectObj" :key="index" class="select-check">
                                  <a-checkbox @change="onChangeCheck(item,index)" :checked="item.isCheck">{{item.name}}</a-checkbox>
                              </div>
                          </div>
                      </div>
                      <div class="select-clear" @click="onClear">清空已选</div>
                  </div>
                  <div class="temp-tab" v-show="showTable">
                      <div class="temp-tab-title">效果预览</div>
                      <div class="temp-table">
                          <div class="temp-th">
                              <div class="temp-th-item" v-for="(item,index) in selectTabObj" :key="index">{{item.name}}</div>
                          </div>
                          <div class="temp-td">
                              <div class="temp-td-item" v-for="(item,index) in selectTabObj" :key="index">{{item.name}}</div>
                          </div>
                      </div>
                  </div>
              </div>

          </model>
          <model :width="1200" :height="370" :title="title1" ref="model1"  :confirmText="confirmText1" @onCofrim="onCofrimForm1" :isShow="isShowModel1" @onCancel="onCancel1">
              <div class="temp-table">
                  <div class="temp-th">
                      <div class="temp-th-item" v-for="(item,index) in thList" :key="index">{{item.name}}</div>
                  </div>
                  <div class="temp-td">
                      <div class="temp-td-item" v-for="(item,index) in thList" :key="index">{{item.name}}</div>
                  </div>
              </div>
          </model>

      </div>
  </div>
</template>
<script>
import cardTemp from '@/components/card-temp'
import model from  '@/components/model'
export default {
  data () {
    return {
        tabIndex:'1',
        cancelText:'取消',
        confirmText:'保存',
        confirmText1:'编辑',
        isShowModel:false,
        isShowModel1:false,
        title:'新增模板',
        title1:'模板名称1',
        temName:'',
        selectObj:[
            {
                name:'商品名称1',
                isCheck:false
            },
            {
                name:'商品名称2',
                isCheck:false
            },
            {
                name:'商品名称3',
                isCheck:false
            },
            {
                name:'商品名称4',
                isCheck:false
            },
            {
                name:'商品名称5',
                isCheck:false
            },
            {
                name:'商品名称6',
                isCheck:false
            },
            {
                name:'商品名称7',
                isCheck:false
            },
            {
                name:'商品名称8',
                isCheck:false
            },
            {
                name:'商品名称9',
                isCheck:false
            },
        ],
        selectTabObj:[],
        thList:[
            {
                name:'商品名称1'
            },
            {
                name:'商品名称2'
            },
            {
                name:'商品名称3'
            },
        ],
        showTable:false,
    }
  },
  methods: {
        /**
        * @description: tab切换（方法描述）
        */
        callbackTab(value){
            this.tabIndex = value
        },
         /**
           * @description: 删除模板（方法描述）
         */
        onDelete(){

        },
      /**
       * @description: 查看模板（方法描述）
       */
        onWatchTemp(){
            this.isShowModel1 = true
        },
      /**
       * @description: 编辑模板（方法描述）
       */
        onEditTemp(){
            this.isShowModel = true
        },
      /**
       * @description: 保存弹框（方法描述）
       */
        onCofrimForm(){
            this.isShowModel = false
            console.log(this.selectTabObj,this.temName)
        },
      /**
       * @description: 取消弹框（方法描述）
       */
        onCancel(){
          this.isShowModel = false
        },
          /**
           * @description: 保存弹框（方法描述）
           */
          onCofrimForm1(){
              this.isShowModel1 = false
              this.isShowModel = true
              this.onClear()
          },
          /**
           * @description: 取消弹框（方法描述）
           */
          onCancel1(){
              this.isShowModel1 = false
          },
      /**
       * @description: 新增模板（方法描述）
       */
        onAddTemp(index){
            this.isShowModel = true
            this.temName = ''
            this.onClear()
            if(index == 1){

            }else{

            }
        },
      /**
       * @description: 字段选择（方法描述）
       */
        onChangeCheck(item,index){
            item.isCheck = !item.isCheck
            if(item.isCheck){
                this.showTable = true
                this.showTable = true
                this.selectTabObj.push(item)
            }else{
                this.$comm.removeByValue(this.selectTabObj,item)
            }

        },
      /**
       * @description: 清空选择（方法描述）
       */
      onClear(){
        this.selectObj.forEach((item)=>{
            item.isCheck = false
        })
        this.showTable = false
        this.selectTabObj = []
      }

  },
  components: {
      cardTemp,model,
  },
  watch: {

  },
  mounted () {

  },
  created () {

  }
}
</script>
<style lang="scss">
    .a-tabs-theme{
        .ant-tabs-bar{
            padding-left: 20px;
            padding-bottom: 20px;
        }
        .ant-tabs-content{
            padding-left: 20px;
        }
    }
    .ant-checkbox-wrapper{
        width: 100%;
    }
</style>
<style lang="scss" scoped>
  .temp-tip{
      display: flex;
      background: #E9F1FF;
      padding-top: 10px;
      padding-left: 30px;
      height: 60px;
      color: #888888;
      font-size: 12px;
      .temp-tip-left{
          img{
              width: 17px;
              margin-right: 10px;
          }
      }
  }
  .temp-content{
      padding-top:33px ;
      .account-li{
          height: 168px;
      }
      .card-item{
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #555555;
          font-size: 16px;
          .card-button{
              display: flex;
              margin-top: 36px;
              .btn-watch{
                //   cursor: pointer;
                  margin-right: 14px;
              }
              .btn-edit{
                  cursor: pointer;
              }
          }
      }
  }
  .select-content{
      padding-bottom: 40px;
      padding-left: 30px;
  }
  .temp-select{
      display: flex;
      flex-direction: column;
      .select-left{
          flex: 1;
          display: flex;
          margin-bottom: 10px;
          align-items: self-start;
          .select-duan-left{
              display: flex;
              align-items: center;
             .star{
                 margin-right: 10px;

             }
          }
          .select-duan-right{
              margin-left: 15px;
              width: 1000px;
              padding: 24px;
              overflow-y: auto;
              border: 1px solid #DDDDDD;
              display: flex;
              flex-wrap: wrap;

          }
          .select-input{
              width: 420px;
              margin-left: 15px;
          }
          .select-check{
              height: 40px;
              line-height: 40px;
              padding-left: 15px;
          }
      }
      .select-clear{
          cursor: pointer;
          color: #FD5621;
          font-size: 14px;
          margin-left: 90px;
          margin-bottom: 30px;
      }
  }
  .temp-tab{
      display: flex;
      padding-right: 45px;
      .temp-tab-title{
          color: #333333;
          font-size: 14px;
          width: 95px;
          text-align: right;
          padding-right: 10px;
      }
  }
  .temp-table{
      width: 100%;
      height: 120px;
      border: 1px solid #DDDDDD;
      .temp-th{
          height: 60px;
          background: #F8F8FB;
          display: flex;
          .temp-th-item{
              flex: 1;
              text-align: center;
              line-height: 60px;
          }
      }
      .temp-td{
          height: 60px;
          display: flex;
          .temp-td-item{
              flex: 1;
              text-align: center;
              line-height: 60px;
          }
      }
  }
</style>
